import { Component, OnDestroy, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';
import swal from 'sweetalert2';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ProcessService } from 'src/app/service/process.service';
import { Subscription } from 'rxjs';
import { NotifierService } from 'angular-notifier';
import { DndDropEvent } from 'ngx-drag-drop';
import { AttributeService } from 'src/app/main/dynamic/service/attribute.service';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';
import { OptionModel } from 'src/app/main/dynamic/model/option.model';
import { DynamicEvent } from 'src/app/main/dynamic/dynamic.event';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import { MessageService } from 'src/app/service/message.service';
import { MaskApplierService } from 'ngx-mask';
import { CurrencyService } from 'src/app/service/currency.service';

@Component({
  selector: 'app-repeater',
  templateUrl: './repeater.component.html',
  styleUrls: ['./repeater.component.scss'],
  animations: [
    trigger('fadeAnimation', [
      state('in', style({opacity: 1})),
      transition(':enter', [
        style({opacity: 0}),
        animate(400)
      ]),
      transition(':leave',
        animate(200, style({opacity: 0})))
    ])
  ]
})
export class RepeaterComponent extends ComponentBase implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('repeaterContainer') repeaterContainer: ElementRef;

  private loadingSubscription: Subscription
  private message
  private _items: AttributeModel[] = [];
  private _data: AttributeModel[] = [];
  protected collapseMenuIndex: number | null = null;
  protected tabMenuIndex: number | null = null; 
  subscription: Subscription;
  totalSelectedValue: number = 0;
  totalParcelValue: number = 0;
  totalReceivables: number = 0;
  isAllCollapsed: boolean = true;
  showFixedCounter: boolean = false;

  // Propriedades de paginação
  currentPage: number = 1;
  itemsPerPage: number = 10;
  paginatedItems: AttributeModel[] = [];
  totalPages: number = 0;

  constructor(
    private attributeService: AttributeService,
    private sharedData: SharedDataService,
    private notifier: NotifierService,
    private messageService: MessageService,
    protected currencyService: CurrencyService,
    maskService: MaskApplierService,
    processService: ProcessService) {
      super(maskService)

      this.loadingSubscription = processService.getLoadingNotification().subscribe((isLoaded) => {
        if(isLoaded) {
          this.sendItemsToSharedData()
        }
      })
    }

  currentItemTitle: string;
  title: string
  itemKey: string;
  itemTitle: string;
  itemsTitles: string[] = [];
  template: AttributeModel;
  layout: string;

  get allowAddItems(): boolean {
    let maxValueOpt = this.attribute.options
      .find(opt => opt.key.toLowerCase() == "MaximumAmount".toLowerCase())

    if(maxValueOpt) {
      return +maxValueOpt.value > this.items.length;
    }

    return true;
  }

  get fieldsSum(): number {
    if(this.summaryField) {
      let sum = 0
      this.items.forEach(item => {
        let summaryFieldAttr = item.attributes
          .find(attr => attr.key.toLowerCase() == this.summaryField.toLowerCase())

        if(summaryFieldAttr) {
          sum += +summaryFieldAttr.value
        }
      })

      return sum
    } else {
      return 0
    }
  }

  get fieldSumMaxValue() : number {
    let fieldSumMaxValueOpt = this.template.options
      .find(opt => opt.key.toLowerCase() == "fieldSumMaxValue".toLowerCase())

    if(fieldSumMaxValueOpt) {
      return +fieldSumMaxValueOpt.value
    }

    return 0
  }

  get hasCopiedAttribute() {
    if(localStorage.getItem('copiedAttribute')) {
      return true
    } else {
      return false
    }
  }

  get hasFieldSumMaxValue() : boolean {
    let fieldSumMaxValueOpt = this.template.options
      .find(opt => opt.key.toLowerCase() == "fieldSumMaxValue".toLowerCase())

    if(fieldSumMaxValueOpt) {
      return true
    }

    return false
  }

  get items(): AttributeModel[] {
    return this._items;
  }
  
  set items(value: AttributeModel[]) {
    this._items = value;
    this.updatePagination();
  }

  get data(): AttributeModel[] {
    return this._data;
  }
  
  set data(value: AttributeModel[]) {
    this._data = value;
  }

  get isPrintMode(): boolean {
    return this.envOptions.some(e =>
      e.key.toLowerCase() == "printmode" && e.value.toLowerCase() == "true")
  }

  get showFieldSumMaxValue() : boolean {
    let showFieldSumMaxValueOpt = this.template.options
      .find(opt => opt.key.toLowerCase() == "showFieldSumMaxValue".toLowerCase())

    if(showFieldSumMaxValueOpt) {
      return true
    }

    return false
  }

  get showItemCheckbox(): boolean {
    let showCheckboxOpt = this.attribute.options
      .find(opt => opt.key.toLowerCase() == "show item checkbox");

    if(showCheckboxOpt && showCheckboxOpt.value) {
      return showCheckboxOpt.value.toLowerCase() == "true";
    }

    return false;
  }

  get summaryField(): string  {
    let summaryFieldOpt = this.template.options
      .find(opt => opt.key.toLowerCase() == "summaryField".toLowerCase())

    if(summaryFieldOpt) {
      return summaryFieldOpt.value
    }

    return null
  }

  get templateTitle(): string  {
    let titleOpt = this.template.options
      .find(opt => opt.key.toLowerCase() == "title")

    if(titleOpt) {
      return titleOpt.value
    }

    return this.template.key
  }

  get totalSelectedValueFormated(): string {
    const rawCents = this.getTotalAsCentString();
    const currencyMask = this.currencyService.getCurrencyMaskText(rawCents);
    return this.maskService.applyMask(rawCents, currencyMask);
  }

  get showCheckedCounter(): boolean {
    return this.attribute.options
      .some(opt => opt.key.toLowerCase() === "checked counter field");
  }

  ngOnInit() {
    const savedCollapseIndex = sessionStorage.getItem(`${this.getId(this.attribute)}_collapseIndex`);
    this.collapseMenuIndex = savedCollapseIndex !== null ? parseInt(savedCollapseIndex, 10) : null;

    const savedTabIndex = sessionStorage.getItem(`${this.getId(this.attribute)}_tabIndex`);
    this.tabMenuIndex = savedTabIndex !== null ? parseInt(savedTabIndex, 10) : null;

    let titleOpt = this.attributeService.getOptionBy(this.attribute, "title")

    if(titleOpt) {
      this.title = titleOpt.value;
    }

    let layoutOpt = this.attributeService.getOptionBy(this.attribute, "layout");

    if (!layoutOpt) {
      this.layout = "collapse";
    }
    else {
      this.layout = layoutOpt.value;
    }

    this.template = this.attribute.attributes
      .find(attr => attr.type.toLowerCase() == "template");

    let itemsAttr = this.attribute.attributes
      .find(attr => attr.type.toLowerCase() == "items")

    if(!itemsAttr) {
      itemsAttr = {
        key: "items",
        type: "items"
      }
      this.attribute.attributes.push(itemsAttr)
    }

    this.itemKey = itemsAttr.key

    let templateTitleOpt = this.template.options
      .find(opt => opt.key.toLowerCase() == "title")

    if(templateTitleOpt) {
      this.itemTitle = templateTitleOpt.value
    }

    this.items = itemsAttr.attributes

    let dataAttr = this.attribute.attributes
      .find(attr => attr.type.toLowerCase() == "object")

    if(dataAttr) {
      this.data = dataAttr.attributes
    }

    if(this.items.length > 0) {
      this.sendItemsToSharedData()
    }

    if (this.layout === 'tab' && this.items.length > 0) {
      if (this.tabMenuIndex !== null && this.items[this.tabMenuIndex]) {
        this.ativarTab(this.items[this.tabMenuIndex]);
      } else {
        this.tabMenuIndex = 0;
        this.ativarTab(this.items[0]);
        sessionStorage.setItem(`${this.getId(this.attribute)}_tabIndex`, '0');
      }
    }

    this.calculateTotalSelectedValue();

    setTimeout(() => {
      const counterContainer = document.querySelector('.counter-container');
      if (counterContainer) {
        if (!this.isCounterVisible()) {
          counterContainer.classList.add('fixed');
        } else {
          counterContainer.classList.remove('fixed');
        }
      }
    }, 100);
  }

  private calculateTotalSelectedValue() {
    const counterFieldOpt = this.attribute.options
      .find(opt => opt.key.toLowerCase() === "checked counter field");

    if (counterFieldOpt) {
      this.totalSelectedValue = this.calculateCheckedFieldsSum(this.attribute, counterFieldOpt.value);
    }
  }

  private recalculateCheckedCounterAndPersist(): void {
    const counterFieldOpt = this.attribute.options
      .find(opt => opt.key.toLowerCase() === "checked counter field");

    if (counterFieldOpt) {
      const totalValue = this.calculateCheckedFieldsSum(this.attribute, counterFieldOpt.value);
      this.totalSelectedValue = totalValue;
      this.updateData(counterFieldOpt.value, totalValue.toString());
    }
  }

  private calculateCheckedFieldsSum(attribute: AttributeModel, counterFieldKey: string): number {
    let sum = 0;
    const counterFieldKeyLower = counterFieldKey.toLowerCase();

    const itemsAttr = attribute.attributes.find(attr => attr.type.toLowerCase() === 'items');
    if (itemsAttr) {
      for (const item of itemsAttr.attributes) {
        const counterField = item.attributes.find(attr => 
          attr.key.toLowerCase() === counterFieldKeyLower
        );

        if (counterField && this.isChecked(item)) {
          sum += this.parseCounterValueToCents(counterField.value);
        }

        const nestedRepeaters = item.attributes.filter(a => a.type.toLowerCase() === 'repeater');
        for (const nestedRepeater of nestedRepeaters) {
          sum += this.calculateCheckedFieldsSum(nestedRepeater, counterFieldKey);
        }
      }
    }

    return sum;
  }

  private isCounterVisible(): boolean {
    const counterElement = document.querySelector('.counter-container');
    if (counterElement) {
      const rect = counterElement.getBoundingClientRect();
      return rect.top >= 0 && rect.bottom <= window.innerHeight;
    }
    return false;
  }

  ngDoCheck(){
    this.subscription = this.messageService.getMessage().subscribe(message => { this.message = message });
    if(this.message){
      if ($(`[href="#${this.message.text}"]`).length > 0) {
        ($(`[href="#${this.message.text}"]`) as any).tab('show');
        setTimeout(() => {
          this.messageService.clearMessage()
        }, 100);
      }
    }
  }

  add() {
    let attribute = this.attributeService.copy(this.template);

    this.addAttribute(attribute);
  }

  addDefault() {
    let attribute = this.attributeService.copy(this.template);

    this.addAttribute(attribute, false);
  }

  private addAttribute(attribute: AttributeModel, save: boolean = true, index?: number) {
    attribute.key = this.getNewItemKey()
    attribute.type = "item";

    if(index) {
      this.items.splice(index, 0, attribute)
    } else {
      this.items.push(attribute);
    }

    this.updatePagination();
    
    if (this.currentPage !== this.totalPages) {
      this.currentPage = this.totalPages;
    }
    if (this.layout === 'collapse') {
      const globalIndex = (index !== undefined) ? index : (this.items.length - 1);
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const pageIndex = globalIndex - startIndex;
      this.collapseMenuIndex = pageIndex;
      this.isAllCollapsed = false;
      sessionStorage.setItem(`${this.getId(this.attribute)}_collapseIndex`, pageIndex.toString());
    }

    this.ativarTab(attribute);
    this.sendItemsToSharedData();

    if(save) {
      this.emit({ name: "autosave", data: "silently" })
    }
  }

  duplicate(item: AttributeModel, index: number) {
    let newAttr = <AttributeModel>JSON.parse(JSON.stringify(item))

    let identifier = newAttr.attributes
      .find(a => a.type.toLowerCase() == "text" &&
                 a.options.some(opt => opt.key.toLowerCase() == "required" &&
                                       opt.value.toLowerCase() == "true") &&
                 a.options.some(opt => opt.key.toLowerCase() == "sharedata" &&
                                       opt.value.toLowerCase() == "true"))

    if(identifier) {
      identifier.value += " Copy"
    }

    this.resetUids(newAttr)

    this.addAttribute(newAttr, true, ++index)
  }

  getEmptyFirstMessage(templateTitle: string): string {
    const baseText = "Adicione ";
    let finalText = "";

    if (templateTitle.endsWith("a") || templateTitle.endsWith("as")) {
        finalText = baseText + "a primeira ";
    } else {
        finalText = baseText + "o primeiro ";
    }

    finalText += "aqui.";

    return finalText;
  }

  getEmptyRepeaterTitle(templateTitle: string): string {
    const defaultText = "Você ainda não tem ";
    
    if (templateTitle.endsWith("a") || templateTitle.endsWith("as")) {
        return defaultText + "nenhuma " + templateTitle;
    } else {
        return defaultText + "nenhum " + templateTitle;
    }
  }

  getEnvOptions(currentItem: string): OptionModel[] {
    let viewModeOpt = this.attribute.options
      .find(opt => opt.key.toLowerCase() == "viewmode")

    if(viewModeOpt) {
      this.envOptions = this.envOptions.filter(opt => opt.key.toLowerCase() !== "viewmode");

      this.envOptions.push({
        key: viewModeOpt.key,
        value: viewModeOpt.value,
        type: viewModeOpt.type
      });
    }

    let bindingContext = this.envOptions.find(opt =>
      opt.key.toLowerCase() == "BindingContext".toLowerCase())

    if(!bindingContext) {
      this.envOptions.push({
        key: "BindingContext",
        value: currentItem,
        type: "Text"
      })
    }

    return this.envOptions;
  }

  getId(attribute: AttributeModel): string {
    if(!attribute)
      return;

    let ex = new RegExp(" ", "g")
    let atual = attribute.key.replace(ex, "").toLowerCase();

    if (!this.parent)
      return atual;

    return this.parent.key.replace(ex, "").toLowerCase() + atual;
  }

  getItemTitle(item: AttributeModel, index: number): string[] {
    if (index == 0) {
        this.itemsTitles = [];
    }

    let titles: string[] = [];
    this.getItemTitleRecursive(item, titles);

    if (titles.length > 0) {
        const joined = titles.join(" | ");
        this.itemsTitles.push(joined);
        this.currentItemTitle = joined;
        return titles;
    } else if (this.itemTitle) {
        this.itemsTitles.push(this.itemTitle);
        return [this.itemTitle];
    } else {
        return [item.key];
    }
  }

  public getOcurrencesNumber(title: string): string {
    let number = this.itemsTitles
      .filter(i => i == title)
      .length

    if(number > 1) {
      return `(${number})`
    } else {
      return ""
    }
  }

  private getItemTitleRecursive(item: AttributeModel, titles: string[], depth: number = 0) {
    let isRepeaterTitle = item.options
      .find(opt => opt.key.toLowerCase() == "isRepeaterTitle".toLowerCase() &&
                   opt.value && opt.value.toLowerCase() == "true")

    let itemValue = this.getItemValue(item)

    if(isRepeaterTitle && itemValue) {
      const fieldName = this.getItemKey(item);

      if(fieldName) {
        titles.push(`${this.getItemKey(item)}: ${this.getLimitedText(itemValue)}`);
      } else {
        titles.push(`${this.getLimitedText(itemValue)}`);
      }
    }

    if(depth <= 2) {
      depth++

      item.attributes.forEach(childItem =>
        this.getItemTitleRecursive(childItem, titles, depth))
    }
  }

  private getItemKey(item: AttributeModel) {
    var showTitleOpt = item.options
      .find(opt => opt.key.toLowerCase() == "showfieldname");

    if(!showTitleOpt || showTitleOpt.value.toLowerCase() == "true") {
      const titleOpt = item.options
        .find(opt => opt.key.toLowerCase() == "title");

      if(titleOpt) {
        return titleOpt.value;
      }

      return item.key;
    } else {
      return null;
    }
  }

  private getItemValue(item: AttributeModel) {
    if(item.type.toLowerCase() == "collection") {
      return this.getCollectionValue(item)
    } else if(item.type.toLowerCase() == "collectionmultiple") {
      return this.getCollectionMultipleValue(item)
    } else if(item.type.toLowerCase() == "number") {
      return this.getMaskedNumber(item)
    } else if (item.type.toLowerCase() === 'processselect') {
      return this.getProcessSelectValue(item);
    } else {
      return this.getMaskedValue(item)
    }
  }

  private getMaskedNumber(item: AttributeModel) {
    return this.maskService.applyMask(item.value, `separator`)
  }

  private getProcessSelectValue(item: AttributeModel): string {
    const selectedOption = item.attributes.find(attr => 
        attr.type.toLowerCase() === 'processselectedoption'
    );

    if (selectedOption) {
        return selectedOption.value || '';
    }

    return '';
  }

  private getMaskedValue(item: AttributeModel) {
    let maskOpt = item.options.find(opt => opt.key.toLowerCase() == "mask")

    if(maskOpt) {
      let maskPattern = "";

      if(maskOpt.value.toLowerCase() == "date" ||
         maskOpt.value.toLowerCase() == "date br") {
        const date = new Date(item.value);
        return this.formatDateToBR(date);
      }
      else if(maskOpt.value.toLowerCase() == "document") {
        maskPattern = this.getDocumentMask(item)
      } else if(maskOpt.value.toLowerCase() == "phone") {
        maskPattern = this.getPhoneMask(item)
      } else if(maskOpt.value.toLowerCase() == "currency") {
        maskPattern = this.getCurrencyMaskText(item)
      } else {
        maskPattern = maskOpt.value;
      }

      return this.applyPrefix(this.maskService.applyMask(item.value, maskPattern), maskOpt);
    }

    return item.value;
  }

  private applyPrefix(value: string, maskOpt: OptionModel): string {
    if(maskOpt && maskOpt.value.toLowerCase() == "currency") {
      return `R$ ${value}`;
    }

    return ''; 
  }

  private getCollectionValue(item: AttributeModel) {
    let foundOption = item.attributes.find(attr => attr.key == item.value)

    if(foundOption) {
      return foundOption.value
    } else {
      return item.value
    }
  }

  private getCollectionMultipleValue(item: AttributeModel) {
    let selecteds = item.value ? item.value.split(',') : [];

    return selecteds
      .map(key => {
        let foundItem = item.attributes.find(i => i.key == key)

        if(foundItem) {
          return foundItem.value
        } else {
          return key
        }
      })
      .join(", ");
  }

  private getLimitedText(text: string) {
    if(text.length > 72) {
      return `${text.substring(0, 68)}...`;
    }

    return text
  }

  handleEvent(events: DynamicEvent[]) {
    events.forEach(e => this.processEvent(e))

    this.emitEvents(events)
  }

  private processEvent(event: DynamicEvent): void {
    if(event.name == "shareData" && event.attribute) {
      let matchKey = event.attribute.options
        .some(opt => opt.key.toLowerCase() == "SharedDataKey".toLowerCase() &&
                     opt.value.toLowerCase() == this.attribute.key.toLowerCase())

      if(matchKey) {
        this.sharedData.reset(this.attribute.key, "items")
        this.sendItemsToSharedData()
      }
    }

    if(event.name == "autosave") {
      this.recalculateCheckedCounterAndPersist();
    }
  }

  isChecked(item: AttributeModel): boolean {
    const isCheckedOpt = item.options
      .find(opt => opt.key.toLowerCase() == "checked");

    if(isCheckedOpt && isCheckedOpt.value) {
      return isCheckedOpt.value.toLowerCase() == "true";
    }

    return false;
  }

  isCollapseMenuOpened(index: number) {
    return this.collapseMenuIndex == index;
  }
  isTabMenuOpened(index: number) {
    return this.tabMenuIndex == index;
  }

  onArrowUp(index: number){
    if(index-1 < 0 || index >= this.items.length) {
      return
    }

    let targetIndex = index-1;
    let currentElement = this.items[index];
    this.items[index] = this.items[targetIndex];
    this.items[index-1] = currentElement;
    this.collapseMenuIndex = targetIndex;

    this.emit({ name: "autosave", data: "silently" })
  }

  onArrowDown(index: number){
    if(index+1 >= this.items.length) {
      return
    }

    let targetIndex = index+1;
    let currentElement = this.items[index];
    this.items[index] = this.items[targetIndex];
    this.items[index+1] = currentElement;
    this.collapseMenuIndex = targetIndex;

    this.emit({ name: "autosave", data: "silently" })
  }

  onCheckboxChange(event: Event, item: AttributeModel) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.setChecked(item, isChecked);

    this.recalculateCheckedCounterAndPersist();

    this.emit({ 
      name: "autosave", 
      data: "silently" 
    });
  }

  private setChecked(item: AttributeModel, isChecked: boolean) {
    let itemIsChecked = item.options
      .find(opt => opt.key.toLowerCase() == "checked");

    if (itemIsChecked) {
      itemIsChecked.value = isChecked.toString();
    } else {
      item.options.push({
        key: "checked",
        value: isChecked.toString(),
        type: "Boolean"
      });
    }

    this.switchChildrenRepeaters(item, isChecked);
  }

  private switchChildrenRepeaters(item: AttributeModel, ischecked: boolean) {
    const repeaterAttr = item.attributes
      .find(attr => attr.type.toLowerCase() == "repeater");

    if(repeaterAttr) {
      const repeaterItemsAttr = repeaterAttr.attributes
        .find(attr => attr.type.toLowerCase() == "items");

      if(repeaterItemsAttr) {
        repeaterItemsAttr.attributes.forEach(i => this.setChecked(i, ischecked));
      }
    }
  }

  onCopyToClipboard(item: AttributeModel){
    let copiedAttr = this.cloneItem(item);
    localStorage.setItem('copiedAttribute', JSON.stringify(copiedAttr))
    this.showNotification('default', 'Campo copiado')
    this.collapseMenuIndex = null
  }

  onCutToClipboard(item: AttributeModel, index: number){
    let copiedAttr = this.cloneItem(item);
    localStorage.setItem('copiedAttribute', JSON.stringify(copiedAttr))
    this.remove(index)
    this.showNotification('default', 'Campo recortado')
    this.collapseMenuIndex = null
  }

  onDrop(event: DndDropEvent) {
    const stepKey = event.data;
    let targetIndex = event.index;
    let originIndex = this.items.findIndex(i => i.key == stepKey);

    var element = this.items[originIndex];
    this.items.splice(originIndex, 1);
    this.items.splice(targetIndex, 0, element);

    this.emit({ name: "autosave", data: "silently" })
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(
      this.items,
      event.previousIndex,
      event.currentIndex
    );

    this.emit({ name: "autosave", data: "silently" })
  }

  onRemove(index: number) {
    if(!this.checkViewMode('edit')) {
      return;
    }

    swal.fire({
      title: 'Deseja excluir?',
      text: "O conteúdo preenchido será apagado.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
    }).then((result) => {
      if (result.value) {
        this.remove(index);
        this.collapseMenuIndex = null
      }
    })
  }

  private remove(index: number) {
    let removedIsActive = $('#' + this.getId(this.items[index])).hasClass('active');

    this.items.splice(index, 1);

    let i = 1;

    this.items.filter(item => !this.isFixed(item)).forEach(element => {
      element.key = this.itemKey + " - " + i++;
    });

    this.sharedData.reset(this.attribute.key, "items");

    if (this.items.length > 0) {
      this.sendItemsToSharedData(); 
    }

    this.updatePagination();
    
    if (this.paginatedItems.length === 0 && this.currentPage > 1) {
      this.currentPage--;
      this.updatePagination();
    }

    this.emit({ name: "autosave", data: "silently" });

    if (removedIsActive) {
      this.ativarTab(this.items[0]);
    }
  }

  isFixed(attribute: AttributeModel): boolean {
    let isFixed = this.getOptionByKey(attribute, "fixed");

    if (isFixed.toLowerCase() == "true")
      return true;
    else
      return false;
  }

  paste() {
    let copiedAttribute = <AttributeModel>JSON.parse(localStorage.getItem('copiedAttribute'))

    if(copiedAttribute) {
      copiedAttribute.key = this.getNewItemKey();
      this.items.push(copiedAttribute)
      localStorage.removeItem('copiedAttribute')
      this.emit({ name: "autosave", data: "silently" })
    }
  }

  permiteExcluirTab(attribute: AttributeModel): boolean {
    let isFixed = this.isFixed(attribute);

    if (isFixed)
      return false;

    return this.checkViewMode("edit");
  }

  toggleTabMenu(index: number) {
    if (this.tabMenuIndex === index) {
      this.tabMenuIndex = null;
      sessionStorage.removeItem(`${this.getId(this.attribute)}_tabIndex`);
    } else {
      this.tabMenuIndex = index;
      sessionStorage.setItem(`${this.getId(this.attribute)}_tabIndex`, index.toString());
    }
    
    if (this.items[index]) {
      this.ativarTab(this.items[index]);
    }
  }

  private ativarTab(attribute: AttributeModel): void {
    if (this.layout !== "tab" || this.items.length === 0) return;

    const id = this.getId(attribute);
    
    setTimeout(() => {
      const repeaterContainer = document.querySelector(`[id="${this.getId(this.attribute)}"]`);
      if (!repeaterContainer) return;

      repeaterContainer.querySelectorAll('.tab-pane').forEach(pane => {
        pane.classList.remove('active');
      });

      const selectedPane = repeaterContainer.querySelector(`#${id}`);
      if (selectedPane) {
        selectedPane.classList.add('active');
        const index = this.items.findIndex(item => this.getId(item) === id);
        if (index !== -1) {
          sessionStorage.setItem(`${this.getId(this.attribute)}_tabIndex`, index.toString());
          this.tabMenuIndex = index;
        }
      }
    }, 0);
  }

  private sendItemsToSharedData() {
    let index = 1
    this.items.forEach(item => {
      let sharedField = item.attributes.find(attr =>
        attr.options.some(opt => opt.key.toLowerCase() == "sharedata" &&
                                 opt.value.toLowerCase() == "true") &&
        attr.options.some(opt => opt.key.toLowerCase() == "SharedDataKey".toLowerCase() &&
                                 opt.value.toLowerCase() == this.attribute.key.toLowerCase()))

      if(sharedField && sharedField.value) {
        let title: string = ""
        let titleOpt = item.options.find(opt => opt.key.toLowerCase() == "title prefix")

        if(titleOpt) {
          title = `${titleOpt.value} ${index} - `
        }

        title += sharedField.value

        this.sharedData.setItem(this.attribute.key, { key: sharedField.value, value: title }, "items")
      }

      index++
    })
  }

  showNotification(type: string, message: string): void {
    this.notifier.notify(type, message);
  }

  toggleCollapseMenu(index: number) {
    if (this.collapseMenuIndex === index) {
      this.collapseMenuIndex = null;
      this.isAllCollapsed = true;
      sessionStorage.removeItem(`${this.getId(this.attribute)}_collapseIndex`);
    } else {
      this.collapseMenuIndex = index;
      this.isAllCollapsed = false;
      sessionStorage.setItem(`${this.getId(this.attribute)}_collapseIndex`, index.toString());
    }
  }

  private cloneItem(item: AttributeModel) {
    let newAttr = <AttributeModel>JSON.parse(JSON.stringify(item));
    this.resetUids(newAttr)
    newAttr.key = this.getNewItemKey();
    return newAttr;
  }

  private resetUids(newAttr: AttributeModel) {
    newAttr.uid = null

    let setEmptyValue = newAttr.options.some(opt =>
      opt.key.toLowerCase() == "DuplicationStrategy".toLowerCase() &&
      opt.value.toLowerCase() == "empty")

    if(setEmptyValue) {
      newAttr.value = null
    }

    newAttr.attributes.forEach(attr => this.resetUids(attr))
  }

  private getNewItemKey(): string {
    return this.itemKey + " - " + (this.items.filter(i => !this.isFixed(i)).length + 1);
  }

  ngOnDestroy() {
    this.loadingSubscription.unsubscribe();
  }

  private updateData(key: string, value: string) {
    let dataAttr = this.data.find(attr => 
      attr.key.toLowerCase() == key.toLowerCase());
    
    if (dataAttr) {
      dataAttr.value = value;
    }
  }

  private parseCounterValueToCents(value: any): number {
    if (value === null || value === undefined) return 0;

    if (typeof value === 'string') {
      // Normaliza string de moeda (ex.: "462,90" -> 46290)
      return this.currencyService.getCurrencyStringNoSeparatorNumber(value) || 0;
    }

    const num = +value;
    if (isNaN(num)) return 0;

    // Converte número decimal para centavos
    return Math.round(num * 100);
  }

  private getTotalAsCentString(): string {
    const valueStr = `${this.totalSelectedValue}`;

    if (valueStr.includes('.')) {
      // Se vier como decimal (ex.: "462.90"), normaliza para centavos "46290"
      const fixed = Number(this.totalSelectedValue).toFixed(2);
      return fixed.replace('.', '');
    }

    // Já está em centavos (ex.: "46290")
    return valueStr;
  }

  ngAfterViewInit() {
    this.setupScrollListener();
  }

  private setupScrollListener() {
    window.addEventListener('scroll', () => {
      if (this.repeaterContainer && this.repeaterContainer.nativeElement) {
        const rect = this.repeaterContainer.nativeElement.getBoundingClientRect();
        const bottomVisible = rect.bottom <= window.innerHeight;
        this.showFixedCounter = !bottomVisible;
      }
    });
  }

  private updatePagination() {
    this.totalPages = Math.ceil(this.items.length / this.itemsPerPage);
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.paginatedItems = this.items.slice(startIndex, endIndex);
  }

  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.updatePagination();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.goToPage(this.currentPage + 1);
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.goToPage(this.currentPage - 1);
    }
  }

  getPageNumbers(): number[] {
    const pages: number[] = [];
    const maxVisiblePages = 10;
    let startPage = Math.max(1, this.currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(this.totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  }
}
